async function crossAddToCart(items) {
  $("[js-product-template] [data-loader]").removeClass("d-none");
  $("[js-product-template] [data-add-to-cart-text]").addClass("d-none");

  try {
    await $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: JSON.stringify({ items: items }),
      dataType: "json",
      contentType: "application/json",
    });

    for (const item of items) {
      await addMiniCartNotification(item.id);
    }

    $("[js-product-template] .js-product-message").addClass("d-none");
  } catch (error) {
    $("[js-product-template] .js-product-message").removeClass("d-none");
    $("[js-product-template] [text-message-warning]")
      .empty()
      .append(error.responseJSON.description);
  } finally {
    $("[js-product-template] [data-loader]").addClass("d-none");
    $("[js-product-template] [data-add-to-cart-text]").removeClass("d-none");
  }
}

function getDiscountPercentage(compareAtPrice, price) {
  if (compareAtPrice > price) {
    let discount = compareAtPrice - price;
    let discountPercentage = (discount / compareAtPrice) * 100;
    return Math.floor(discountPercentage);
  }
  return 0;
}
